// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_od-0";
export var buttonContainer = "_od-3";
export var cancelButton = "_od-4";
export var headerSection = "_od-6";
export var headerTitle = "_od-9";
export var messageSideLeft = "_od-1";
export var messageSideRight = "_od-2";
export var orderNumberContainer = "_od-7";
export var orderNumberLabel = "_od-8";
export var submitButton = "_od-5";